<template>
  <div class="row">
    <b-container class="tarjetas mb-4 pr-0" :class="modoMovil ? 'd-block d-md-none' : 'show'">
      <div class="row col-12 mx-auto px-0" v-if="tipoFicha === 'CARRERA'">
        <!--<TarjetaCarrera
          v-for="(carrera, index) in arregloInstituciones"
          :key="carrera.id"
          :carrera="carrera"
          :margenDerecho="(index + 1) % 4 === 0"
        />-->
        <TarjetaCarrera
          v-for="carrera in arregloInstituciones"
          :key="carrera.id"
          :carrera="carrera"
          :margenDerecho="false"
        />
      </div>
      <div
        class="row col-12 mx-auto px-0"
        v-if="tipoFicha === 'INSTITUCION' || tipoFicha === 'UNIVERSIDAD'"
      >
        <TarjetaInstitucion
          v-for="(institucion, index) in arregloInstituciones"
          :key="index"
          :institucion="institucion"
          :routerFicha="routerFichaIdentificador"
          :origenRedirect="tipoFicha === 'INSTITUCION' ? 'BuscadorIP' : 'BuscadorInstU'"
        />
      </div>
      <div class="row col-12 mx-auto px-0" v-if="tipoFicha === 'CARRERA_U'">
        <!--<TarjetaCarreraUniversitaria
          v-for="(carrera, index) in arregloInstituciones"
          :key="carrera.id"
          :carrera="carrera"
          :margenDerecho="(index + 1) % 4 === 0"
        />-->
        <TarjetaCarreraUniversitaria
          v-for="carrera in arregloInstituciones"
          :key="carrera.id"
          :carrera="carrera"
          :margenDerecho="false"
        />
      </div>
      <Paginacion
        :listado="listadoContenido"
        :perPage="16"
        @listadoArreglos="arregloInstitucionesPaginado"
      />
    </b-container>
  </div>
</template>

<script>
import TarjetaCarrera from "@/components/buscadorTP/TarjetaCarrera";
import Paginacion from "@/components/generales/paginas/Paginacion";
import TarjetaInstitucion from "@/components/generales/tarjetas/TarjetaInstitucion";
import TarjetaCarreraUniversitaria from "@/components/buscadorCU/TarjetaCarreraUniv";
export default {
  name: "VistaTarjetas",
  props: {
    listadoContenido: {
      type: Array
    },
    modoMovil: {
      type: Boolean,
      default: false
    },
    tipoFicha: {
      type: String
    }
  },
  components: {
    TarjetaCarrera,
    Paginacion,
    TarjetaInstitucion,
    TarjetaCarreraUniversitaria
  },
  data() {
    return {
      arregloInstituciones: []
    };
  },
  computed: {
    routerFichaIdentificador() {
      if (this.tipoFicha === "INSTITUCION") {
        return "FichaInstitucion";
      }
      if (this.tipoFicha === "UNIVERSIDAD") {
        return "FichaInstitutoU";
      }
    }
  },
  methods: {
    arregloInstitucionesPaginado(arreglo) {
      this.arregloInstituciones = arreglo;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/paginas/VistaTarjetas.vue